import React, { forwardRef, useState } from "react";

import {
    IconButton,
    Dialog,
    DialogContent,
    DialogTitle,
    Slide,
    Avatar,
    AppBar,
    Toolbar,
    Box,
    Typography,
    useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import PlaylistAddOutlinedIcon from "@mui/icons-material/PlaylistAddOutlined";
import StaticTodoList from "./StaticTodoList";
import SkillAssignments from "../../common/SkillAssignments";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { useTranslation } from "react-i18next";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function StaticTodoListModal({ page }) {
    const { t } = useTranslation()
    const theme = useTheme()
    const [openModal, setOpenModal] = useState(false);
    return (
        <>
            {
                page == "Skill Section" ?
                    <IconButton variant="rounded" onClick={() => setOpenModal(true)}>
                        <FormatListBulletedIcon />
                    </IconButton>
                    :
                    <Avatar onClick={() => setOpenModal(true)} sx={todoButtonStyle}>
                        <PlaylistAddOutlinedIcon sx={{ width: "40px", height: "40px", color: theme.palette.primary.main }} />
                    </Avatar>
            }
            <Dialog
                open={openModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setOpenModal(false)}
                fullWidth
                maxWidth="lg"
                PaperProps={{
                    sx: {
                        width: '97%',
                        borderRadius: "1.8rem",
                        p: { sm: "15px", xs: "5px" },
                        m: { sm: "32px", xs: "5px" },
                    }
                }}
            >
                <DialogTitle
                    sx={{ display: "flex", justifyContent: "flex-end", px: 0, py: 0 }}
                >
                    <AppBar
                        sx={{
                            position: "sticky",
                            borderRadius: "1.8rem 1.8rem 0 0",
                            top: 0,
                            mt: 0,
                            background: theme.palette.primary.main,
                        }}
                    >
                        <Toolbar>
                            <Box
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                }}
                            >
                                <div style={{ width: "1px" }}></div>
                                <Typography variant="h6" component="div">
                                    {t("todoList.title")}
                                </Typography>

                                <Box dispaly="flex">
                                    {/* <SkillAssignments type="time-management" /> */}
                                    <IconButton
                                        style={{ height: 'fit-content', color: "#fff" }}
                                        onClick={() => {
                                            setOpenModal(false)
                                        }}>
                                        <CloseOutlinedIcon />
                                    </IconButton>
                                </Box>
                            </Box>
                        </Toolbar>
                    </AppBar>
                </DialogTitle>
                <DialogContent sx={{ p: 0 }}>
                    <StaticTodoList page="todoList" />
                </DialogContent>
            </Dialog>
        </>
    );
}
const todoButtonStyle = {
    position: "fixed",
    width: 50,
    height: 50,
    padding: "5px",
    right: { md: 30, xs: 30 },
    bottom: 150,
    background: "#fff",
    boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.2)",
    cursor: "pointer",
    color: theme => theme.palette.primary.main,
};